import { FC } from 'react'
import { AvatarProps } from './avatar.types'

export const Avatar: FC<AvatarProps> = ({ src, height = 46, width = 46 }) => {
  return (
    <img
      src={src}
      width={width}
      height={height}
      className={`rounded-full object-contain`}
      alt="profilePicture"
      onError={(e : any) =>
        e.target.src = 'https://numu-content.s3.eu-west-1.amazonaws.com/Profile_Pic.svg'
      }
    />
  )
}